import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateFilterSex = atom({
  key: 'filter.sex',
  default: null as BeaconFilterItem | null,
});

export default stateFilterSex;
